export enum EMediaType {
  Layout = 'layout',
  CianLayout = 'cianLayout',
  Photo = 'photo',
  Video = 'video',
  Component = 'component',
  Tour = 'Tour',
  FloorPlan = 'FloorPlan',
  VideoVk = 'videoVk',
}

interface IMedia<T extends EMediaType> {
  type: T;
  src: string;
}

interface IMediaWithThumbnail extends IMedia<EMediaType.CianLayout | EMediaType.Layout | EMediaType.Photo> {
  thumbnailSrc: string;
}

interface IMediaComponent {
  type: EMediaType.Component | EMediaType.Tour | EMediaType.FloorPlan;
  component: React.ReactNode;
  thumbnailSrc: string;
}

interface IMediaVideo<T extends EMediaType> {
  id: string;
  previewUrl: T extends EMediaType.Video ? undefined : string;
  src: string;
  type: T;
}

export type TMediaVideo = IMediaVideo<EMediaType.Video | EMediaType.VideoVk>;

export type TMedia = TMediaVideo | IMediaWithThumbnail | IMediaComponent;
